// @flow

import Game from '@/lib/game';

// 陽樹の森が完成したことを伝えるメッセージ
export default class {
  static isSatisfied(game: Game): boolean {
    const {
      beechAdultTreesCount,
      cedarAdultTreesCount,
      mapleAdultTreesCount,
      zelkovaAdultTreesCount,
      creAdultTreesCount,
      cherryAdultTreesCount,
    } = game.stats;

    const shadeTreesCount =
      beechAdultTreesCount + cedarAdultTreesCount + mapleAdultTreesCount;

    const sunTreesCount =
      zelkovaAdultTreesCount + creAdultTreesCount + cherryAdultTreesCount;

    const treesCount = sunTreesCount + shadeTreesCount;
    const sunTreesRate = sunTreesCount / treesCount;

    return treesCount >= 10 && sunTreesRate >= 0.7;
  }

  static makeMessage() {
    return {
      uid: 'sun_tree',
      priority: 30,
      title: '植生が陽樹の森に遷移しました',
      body:
        '荒原が陽樹の森に遷移しました。陽樹とはクリやケヤキなどの明るい環境で速く成長する樹種のことです。',
    };
  }
}



// WEBPACK FOOTER //
// ./src/lib/tutorial_event/sun_tree.js